import { render, staticRenderFns } from "./safetyInfo.vue?vue&type=template&id=190daf5d&scoped=true"
import script from "./safetyInfo.vue?vue&type=script&lang=js"
export * from "./safetyInfo.vue?vue&type=script&lang=js"
import style0 from "./safetyInfo.vue?vue&type=style&index=0&id=190daf5d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190daf5d",
  null
  
)

export default component.exports